// Session
export const LOGOUT_MESSAGE = 'Successfully logged out.';
export const LOGOUT_MESSAGE_ERROR = 'Fail to logout.';
export const LOGIN_MESSAGE_SUCCESS = 'Successfully logged in.';
export const LOGIN_MESSAGE_ERROR = 'Wrong credential. Please try again!';
